import { Skeleton } from '@/shared/components/ui/skeleton';

const FilterFieldSkeleton = () => (
  <div className="flex w-full flex-col gap-2 opacity-40">
    <Skeleton className="h-6 w-24" />
    <Skeleton className="h-5 w-32" />
  </div>
);

export const FiltersListSkeleton = () => {
  return (
    <div className="flex flex-col gap-6">
      <FilterFieldSkeleton />
      <FilterFieldSkeleton />
      <FilterFieldSkeleton />
      <FilterFieldSkeleton />
    </div>
  );
};
